import filter from './filter'
import get from './get'
import type from './type'
import retrieve from './retrieve'

export default {
  filter,
  get,
  type,
  retrieve
}



// WEBPACK FOOTER //
// ./src/data/api/selecting_data/index.js